import { jsxs as n, jsx as r } from "react/jsx-runtime";
import m from "react-modal";
import { Button as _ } from "../Button/Button.js";
import { c as u } from "../clsx-OuTLNxxd.js";
import { i as a } from "../checks-C6AyTTQ0.js";
import { RemoveScroll as p } from "react-remove-scroll";
const y = "Drawer-module_overlay__L2jqO",
  b = "Drawer-module_overlay-after-open__Mybd0",
  w = "Drawer-module_overlay-before-close__3c6vo",
  h = "Drawer-module_content__6SMtR",
  C = "Drawer-module_content-after-open__SxaTP",
  D = "Drawer-module_content-before-close__iueIM",
  O = "Drawer-module_header__ZFtMo",
  A = "Drawer-module_title__ZfmIl",
  B = "Drawer-module_body-container__1kblh",
  e = {
    overlay: y,
    overlayAfterOpen: b,
    overlayBeforeClose: w,
    content: h,
    contentAfterOpen: C,
    contentBeforeClose: D,
    header: O,
    title: A,
    bodyContainer: B
  },
  j = _ref => {
    let {
      children: l,
      dataContentName: d,
      title: t,
      className: c,
      onRequestClose: o,
      shouldCloseOnOverlayClick: s,
      shouldCloseOnEsc: i,
      isOpen: v,
      appElement: f
    } = _ref;
    return /* @__PURE__ */n(m, {
      appElement: f,
      onRequestClose: o,
      shouldCloseOnOverlayClick: s,
      shouldCloseOnEsc: i,
      isOpen: v,
      data: {
        "content-name": d
      },
      contentLabel: "modal",
      closeTimeoutMS: 300,
      overlayClassName: {
        base: e.overlay,
        afterOpen: e.overlayAfterOpen,
        beforeClose: e.overlayBeforeClose
      },
      shouldFocusAfterRender: !0,
      shouldReturnFocusAfterClose: !0,
      preventScroll: !0,
      style: {
        overlay: {},
        content: M
      },
      className: {
        base: u(e.content, c),
        afterOpen: e.contentAfterOpen,
        beforeClose: e.contentBeforeClose
      },
      children: [(a(t) || a(o)) && /* @__PURE__ */n("header", {
        className: e.header,
        children: [/* @__PURE__ */r("div", {
          className: e.title,
          children: t
        }), o && /* @__PURE__ */r(_, {
          renderAs: "button",
          variant: "text",
          size: "regular",
          iconName: "close",
          dataContentPiece: "close-drawer",
          onClick: o
        })]
      }), /* @__PURE__ */r(p, {
        enabled: !0,
        forwardProps: !0,
        children: /* @__PURE__ */r("article", {
          className: e.bodyContainer,
          children: l
        })
      })]
    });
  },
  M = {
    position: void 0,
    top: void 0,
    right: void 0,
    left: void 0,
    bottom: void 0,
    border: void 0,
    background: void 0,
    overflow: void 0,
    WebkitOverflowScrolling: void 0,
    borderRadius: void 0,
    outline: void 0,
    padding: void 0
  };
export { j as Drawer };